export class UserGroupParent {
  constructor() {
    this.list = []
  }

  addUserGroup(item) {
    this.list.push(UserGroup.buildFromAPI(item))
  }

  updateUserGroup(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    this.list.splice(index, 1, UserGroup.buildFromAPI(item))
  }

  removeUserGroup(id) {
    const index = this.list.findIndex(el => el.id === id)
    this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  buildFromAPI(obj) {
    if (obj) {
      this.list = obj.map(el => UserGroup.buildFromAPI(el))
    }
    return this
  }
}

export class UserGroup {
  constructor() {
        this.id = null
        this.name = null
      }

  getForAPI() {
    return {
            id: this.id,
            name: this.name,
          }
  }

  static buildFromAPI(obj) {
    const _this = new UserGroup()
    if (obj) {
            _this.id = obj.id
            _this.name = obj.name
          }
    return _this
  }
}
